var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "monitor-stations" } },
    [
      Object.keys(_vm.station_data).length
        ? _c("v-card", { staticClass: "base-popup__wrapper" }, [
            _c(
              "div",
              {
                staticClass: "base-popup__container",
                class: {
                  "base-popup__container--hide-tooltip": !_vm.is_show_control_options
                },
                attrs: { id: "base-popup__capture_range" }
              },
              [
                _vm.is_show_control_options
                  ? _c("div", { staticClass: "base-popup__tooltip" }, [
                      _c(
                        "div",
                        { staticClass: "base-popup__tooltip-title" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "base-popup__tooltip-title__city_info"
                            },
                            [_c("h1", [_vm._v(_vm._s(_vm.zone_selected))])]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "base-popup__tooltip-close-btn",
                              attrs: { color: "white", icon: "" },
                              on: { click: _vm.close_dialog }
                            },
                            [
                              _c("v-icon", { attrs: { color: "white" } }, [
                                _vm._v(
                                  "\n                            icon-close\n                        "
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "base-popup__tooltip-selection" },
                        [
                          _c(
                            "div",
                            { staticClass: "selection-input" },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.rain_select,
                                  id: "tsgraph-select-type",
                                  "item-text": "text",
                                  "item-value": "value",
                                  label: "雨量累積時間"
                                },
                                model: {
                                  value: _vm.rain_selected,
                                  callback: function($$v) {
                                    _vm.rain_selected = $$v
                                  },
                                  expression: "rain_selected"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "selection-input" },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.zone_select,
                                  id: "tsgraph-select-day",
                                  "item-text": "text",
                                  "item-value": "value",
                                  label: _vm.zone_label
                                },
                                model: {
                                  value: _vm.zone_selected,
                                  callback: function($$v) {
                                    _vm.zone_selected = $$v
                                  },
                                  expression: "zone_selected"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "base-popup__content" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "base-popup__content-detail d-flex justify-space-between"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center" },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.is_pad_width
                                  ? _vm.props_svg_sub_title.time
                                  : _vm.props_svg_sub_title.full_title
                              ) +
                              "\n                        "
                          ),
                          !_vm.is_mobile_width
                            ? _c("v-btn", {
                                attrs: { id: "tsgraph-reset-btn", icon: "" }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          !_vm.is_mobile_width
                            ? _c(
                                "v-btn",
                                {
                                  attrs: { id: "tsgraph-download", icon: "" },
                                  on: { click: _vm.save_png }
                                },
                                [
                                  _c("v-icon", { attrs: { color: "black" } }, [
                                    _vm._v(
                                      "\n                                icon-file-download\n                            "
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.is_show_control_options
                            ? _c(
                                "v-btn",
                                {
                                  staticClass: "close-btn",
                                  attrs: { color: "black", icon: "" },
                                  on: { click: _vm.close_dialog }
                                },
                                [
                                  _c("v-icon", { attrs: { color: "black" } }, [
                                    _vm._v(
                                      "\n                                mdi-close\n                            "
                                    )
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.is_mobile_width
                        ? _c(
                            "v-menu",
                            {
                              attrs: { "offset-y": "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                attrs: {
                                                  color: "black",
                                                  dark: "",
                                                  icon: ""
                                                }
                                              },
                                              "v-btn",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [_c("v-icon", [_vm._v("icon-more")])],
                                          1
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2842754205
                              )
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "v-list",
                                [
                                  _c(
                                    "v-list-item",
                                    { on: { click: _vm.save_png } },
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { color: "black" } },
                                        [
                                          _vm._v(
                                            "\n                                    icon-file-download\n                                "
                                          )
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$t("__chart_common.save_image")
                                          ) +
                                          "\n                            "
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "base-popup__content-legend" }, [
                    _c("span", { staticClass: "legend histogram" }),
                    _vm._v(" 累積雨量\n                    "),
                    _c("span", { staticClass: "legend no-data-label" }, [
                      _vm._v("✚")
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("__chart_common.legend_no_data")) +
                        "\n                "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "base-popup__content-graph" },
                    [
                      _c("QpeHistogram", {
                        ref: "chart",
                        attrs: {
                          id: _vm.id,
                          x_axis_band_data: _vm.x_axis_station_data,
                          choosed_band_data: _vm.choosed_station_data,
                          basic_layout_setting: _vm.basic_layout_setting,
                          x_axis: _vm.x_axis,
                          y_axis: _vm.y_axis,
                          is_wrap_tick: _vm.is_wrap_tick
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _c(
            "v-card",
            [
              _c(
                "v-alert",
                { staticClass: "alert", attrs: { value: true, type: "error" } },
                [_vm._v("\n            暫時無法顯示歷史圖表\n        ")]
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }